import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgWhatsapp = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <rect width={23.413} height={23.413} fill="#29B200" rx={11.707} />
      <path
        stroke="#FFF"
        d="m8.12 17.253-3.195.958 1.038-3.17a6.882 6.882 0 1 1 2.158 2.212z"
      />
      <path
        fill="#FFF"
        d="m10.616 9.568-.488-1.173c-.094-.223-.263-.322-.505-.295-.363.04-.674.084-1.023.732-.348.647-.29 1.313-.145 1.685.145.372.74 1.523 1.61 2.374.58.568 1.427 1.088 2.545 1.56.833.233 1.422.305 1.765.217.515-.132.916-.56 1.047-.856.13-.297.208-.685 0-.803a40.92 40.92 0 0 0-1.383-.683c-.18-.112-.336-.072-.469.12-.133.19-.356.429-.67.715-.774-.206-1.336-.484-1.685-.835s-.711-.826-1.087-1.423a.331.331 0 0 1 .151-.386c.21-.139.19-.094.337-.322.099-.152.099-.36 0-.627z"
      />
    </g>
  </svg>
);
const Memo = memo(SvgWhatsapp);
export default Memo;
